import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
import { useStandardAlertStore } from '../../../shared/store/portal/alertStore';
import { BlackFullWidthBtn } from '../../../shared/component/headless/button/BtnBody';
import { getBtnName } from '../../../shared/constants/btnNames';
import { slideInFromBottom } from '../../../shared/component/Animation';
import { MediumIcon } from '../../../shared/component/IconBody';
import logo from '../../../asset/gnb/logo_fit.png';
import { paperTextureMobile } from '../../../shared/component/paperTexture';
import { paddingBottomWithSafeArea } from '../../../shared/constants/safeArea';


const AlertCompMobile: React.FC = () => {
  const { queue, isClosing, isExecuting, executeCurrent } =
    useStandardAlertStore();
  const alertRef = useRef<HTMLDivElement>(null);

  const currentStandardAlert = queue[0];

  useEffect(() => {
    if (alertRef.current) {
      alertRef.current.focus();
    }
  }, []);

  if (queue.length === 0) return null;

  const handleKeyDown = (event: React.KeyboardEvent) => {
    event.stopPropagation();
    if (event.key === 'Escape') {
      event.preventDefault();
      void executeCurrent();
      return;
    }
    if (event.target !== event.currentTarget) return;

    if (event.key !== 'Enter') return;
    event.preventDefault();
    void executeCurrent();
  };

  return (
    <AlertContentMobile ref={alertRef} onKeyDown={handleKeyDown} tabIndex={-1} $isClosing={isClosing}>
      <AlertHeaderMobile>
        <MediumIcon src={logo} alt='logo icon' />
      </AlertHeaderMobile>
      <ContentMobile>{currentStandardAlert.content}</ContentMobile>
      <ButtonContainer>
        <BlackFullWidthBtn
          disabled={isClosing || isExecuting}
          onClick={() => void executeCurrent()}
        >
          {getBtnName('OK')}
        </BlackFullWidthBtn>
      </ButtonContainer>
    </AlertContentMobile>
  );
};

const AlertHeaderMobile = styled.div`
  margin: 6px 0px 12px 0px;
  user-select: none;
`;

export const ContentMobile = styled.h2`
  min-height: 16vw;
  padding: 4vw 0 6vw 0;
  white-space: pre-line;
  line-height: 20px;
  ${({ theme }) => theme.typography.Body_03_2};
`;

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const AlertContentMobile = styled.div<{ $isClosing: boolean }>`
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: fit-content;
  min-height: 24vw;

  padding: 20px 20px ${paddingBottomWithSafeArea('20px')} 20px;
  outline: none;
  
  transform: ${({ $isClosing }) =>
    $isClosing
      ? 'translateY(100%)'
      : 'translateY(0)'
  };
  transition: all 0.5s ease-out;
  ${paperTextureMobile}
  background-color: ${({ theme }) => theme.colors.color_White};
  ${slideInFromBottom}
`;

export default AlertCompMobile;
